<template>
  <div class="mod-config" style="height: 100%">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item style="float: left;">
        <el-button @click="getMinutes()" :type="minute">分钟值</el-button>
        <el-button @click="getHours()" :type="hour">小时值</el-button>
        <el-button @click="getDayAvgs()" :type="day">日均值</el-button>
      </el-form-item>
      <el-form-item style="float: left;margin-left: 6px;" label="选择时间：">
        <el-date-picker v-model="dataForm.dateStr" :picker-options="dataForm.pickerOptions" type="datetimerange"
          range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :format="dataForm.formatTime"
          :value-format="dataForm.formatTime" v-show="minuteValue">
        </el-date-picker>
        <el-date-picker v-model="dataForm.dateStr" :picker-options="dataForm.pickerOptions" type="datetimerange"
          range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :format="dataForm.formatTime"
          :value-format="dataForm.formatTime" popper-class="tpc" v-show="hourValue">
        </el-date-picker>
        <el-date-picker v-model="dataForm.dateStr" :picker-options="dataForm.pickerOptions" type="daterange"
          range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :format="dataForm.formatTime"
          :value-format="dataForm.formatTime" v-show="dayValue">
        </el-date-picker>
      </el-form-item>
      <el-form-item style="float: left;margin-left: 6px;" :label="labelNew + '：'">
        <template>
          <el-input v-model="value" @click.native="handleClick" placeholder="输入关键字进行过滤" style="width: 300px;"
            clearable></el-input>
          <el-tree id="el_Tree" class="filter-tree" :data="hTree" :check-strictly="true"
            :filter-node-method="filterNode" ref="tree" @node-click="handleCheckChange" v-show="isiptShow">
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <!--给设备追加图标-->
              <i v-if="data.deviceStatus == 1" class="iconfont">
                <img src="../../assets/img/yq01.png" alt="" width="16" height="16">
              </i>
              <i v-if="data.deviceStatus == 2" class="iconfont"><img src="../../assets/img/yq02.png" alt="" width="16"
                  height="16"></i>
              <i v-if="data.deviceStatus == 3" class="iconfont"><img src="../../assets/img/yq03.png" alt="" width="16"
                  height="16"></i>
              <i v-if="data.deviceStatus == 4" class="iconfont"><img src="../../assets/img/yq04.png" alt="" width="16"
                  height="16"></i>
              <span>{{ node.label }}</span>
            </span>
          </el-tree>
        </template>
      </el-form-item>
      <el-button @click="search()" type="primary" icon="el-icon-search" style="float: left;"></el-button>
      <el-form-item style="float: right;">
        <el-button v-show="isShow" style="font-size: 16px;" @click="reload()"><i class="el-icon-refresh"></i>
        </el-button>
        <el-button v-show="isShow" @click="echarts()" class="el-icon-s-marketing" style="font-size: 16px;"></el-button>
        <el-button type="success" @click="tempExcel()" v-show="isShow">导出Excel</el-button>
      </el-form-item>
    </el-form>
    <p class="list-p" v-if="this.isShow == false" @click="isiptShow = false">
      <i class="el-icon-warning"></i>
      {{ msg }}
    </p>
    <div style="clear: both;display: block;text-align: left;font-weight: bold;font-size: 16px;" v-show="isShow">
      <label>所属企业：</label>
      <span style="font-weight: initial;min-width: 250px;display: inline-block">{{ ssqy }}</span>
      <label>所属点位：</label>
      <span style="font-weight: initial;">{{ ssdw }}</span>
      <br>
      <label>设备名称：</label>
      <span style="font-weight: initial;min-width: 250px;display: inline-block">{{ sbmc }}</span>
      <label>唯一编码：</label>
      <span style="font-weight: initial;">{{ wybm }}</span>
    </div>
    <el-table v-if="this.dateEnum == 0" :key="Math.random()" :data="dataList" v-loading="dataListLoading"
      v-show="isShow" style="width: 100%;height:calc(100% - 166px);" border stripe
      :header-cell-style="{ background: '#364a5f', color: '#ffffff' }" placement="top">
      <el-table-column width="204" prop="device_record_time" header-align="center" align="center" label="记录时间">
      </el-table-column>
      <el-table-column v-for="(item, index) in tableHead" :key="index" header-align="center" align="center"
        :label="item.title" :prop="item.field">
      </el-table-column>
    </el-table>
    <el-table v-else :key="Math.random()" :data="dataList" v-loading="dataListLoading" v-show="isShow"
      style="width: 100%;height:calc(100% - 166px);" border stripe
      :header-cell-style="{ background: '#364a5f', color: '#ffffff' }" placement="top">
      <el-table-column width="204" sortable prop="device_record_time" header-align="center" align="center" label="记录时间">
      </el-table-column>
      <el-table-column v-for="(item, index) in tableHead" :key="index" header-align="center" align="center"
        :label="item.title" :prop="item.field">
      </el-table-column>
    </el-table>
    <el-pagination v-show="isShow" @size-change="sizeChangeHandle" @current-change="currentChangeHandle"
      :current-page="pageIndex" :page-sizes="[15, 24, 60, 100]" :page-size="pageSize" :total="totalPage"
      layout="prev, pager, next, jumper, total,sizes">
    </el-pagination>
    <div id="datams">
      <label>数据模式：</label>
      <el-select v-model="region" placeholder="请选择活动区域" @change="sjms">
        <el-option label="分页模式" value="shanghai"></el-option>
        <el-option label="全数据模式" value="beijing"></el-option>
      </el-select>
    </div>
    <!-- 图表 -->
    <div id="yhecharts"></div>
  </div>
</template>
<style scoped>
#datams {
  position: absolute;
  z-index: 99999;
  right: 18px;
  top: 60px;
  display: none;
}

#yhecharts {
  width: 100%;
  height: calc(100% - 125px);
  position: absolute;
  top: 117px;
  z-index: 9999;
  display: none;
  background: #fff;
}

.list-p {
  clear: both;
  height: calc(100% - 100px);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 40px;
}

.list-p .el-icon-warning {
  font-size: 50px;
  vertical-align: middle;
}

/deep/ .el-table__body-wrapper {
  overflow-y: scroll;
  height: calc(100% - 70px);
}

/deep/ .el-table td,
/deep/ .el-table th.is-leaf {
  padding: 0 !important;
}

/deep/ .el-table .cell {
  padding: 0 !important;
  height: 64px !important;
  line-height: 64px !important;
}

.el-tree {
  background: #eee;
  height: 300px;
  overflow-y: scroll;
  z-index: 999999;
  position: absolute;
  width: 100%;
}
</style>
<style>
.tpc .el-time-spinner__wrapper {
  width: 100% !important;
}

.tpc .el-scrollbar:nth-of-type(2) {
  display: none !important;
}
</style>
<script>
import $ from 'jquery'
import { excel } from "@/utils";
//全局的chart变量接收
var myChart;
export default {
  data() {
    return {
      region: '分页模式',
      dataForm: {
        dateFromStr: '',
        dateToStr: '',
        companyId: "",
        dateEnum: '0',
        deviceId: "",
        areaId: "",
        dateStr: '',
        formatTime: "yyyy-MM-dd HH:mm",
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > new Date()
          }
        }
      },
      filterText: '',
      hTree: [],
      dataList: [],
      tableHead: [],
      pageIndex: 1,
      pageSize: 60,
      totalPage: 0,
      number: '1',
      value: '',
      options: [],
      labelNew: "选择设备",
      msg: '请输入您的查询条件',
      minute: 'primary',
      hour: '',
      day: '',
      dataListLoading: false,
      isShow: false,
      isiptShow: false,
      sbmc: "",
      ssqy: "",
      ssdw: "",
      wybm: "",
      eightaveraged: {
        legend: [],
        series: [
          {
            name: "", type: "line", stack: "总量", data: [],
          }
        ],
        xaxis: [],
      },
      minuteValue: true,
      hourValue: false,
      dayValue: false,
      colspan: ''
    }
  },
  computed: {

  },
  created() {
    if (this.$route.query.name == undefined) {
      //动态设置默认时间
      this.dataForm.dateStr = [this.$moment(new Date()).add(-1, "days").format("yyyy-MM-DD HH:mm"),
      this.$moment(new Date()).format("yyyy-MM-DD HH:mm")]
      this.hTree = JSON.parse(sessionStorage.getItem("hTree") || "[]");
      if (this.number === "1") {
      } else {
        this.echarts();
      }
      this.dateEnum = '0';
      this.minute = 'primary';
    } else {
      let id = JSON.parse(this.$route.query.name)
      this.dataForm.deviceId = id.id;
      this.value = id.name;
      console.log(this.dataForm.deviceId)
      console.log(this.value)
      setTimeout(index => {
        this.search();
      }, 500)
    }
    //动态设置默认时间
    this.dataForm.dateStr = [this.$moment(new Date()).add(-1, "days").format("yyyy-MM-DD HH:mm"),
    this.$moment(new Date()).format("yyyy-MM-DD HH:mm")]
    this.hTree = JSON.parse(sessionStorage.getItem("hTree") || "[]");

    if (this.number === "1") {
    } else {
      this.echarts();
    }
    this.dateEnum = '0';
    this.minute = 'primary';
  },
  watch: {
    value(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex > 0) {
        if (row.deviceId == null) {
          return {
            rowspan: 1,
            colspan: this.colspan
          };
        }
      }
    },
    search() {
      this.pageIndex = 1;
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      loading.close();
      this.getDataList();
    },
    sjms(event) {
      if (event == "shanghai") {
        this.getDataList();
      } else {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        if (this.dataForm.dateStr) {
          this.dataForm.dateFromStr = this.dataForm.dateStr[0]
          this.dataForm.dateToStr = this.dataForm.dateStr[1]
        } else {
          this.$message.warning("请选择要查询的时间")
        }
        this.$http({
          url: this.$http.adornUrl("/device/record/echarts/all"),
          method: "get",
          params: this.$http.adornParams({
            'deviceId': this.dataForm.deviceId,
            'dateFromStr': this.dataForm.dateFromStr,
            'dateToStr': this.dataForm.dateToStr,
            'dateEnum': this.dateEnum,
          })
        }).then(({ data }) => {
          loading.close();
          if (data && data.code === 200) {
            if (data.data.length !== 0) {
              this.eightaveraged = data.data.echarts;
              // 基于准备好的dom，初始化echarts实例 绘制图表
              document.getElementById('yhecharts').innerHTML = "";
              document.getElementById("yhecharts").removeAttribute("_echarts_instance_");
              myChart = this.$echarts.init(document.getElementById('yhecharts'))
              myChart.setOption({
                tooltip: {
                  trigger: 'axis',
                  textStyle: {
                    align: 'left'
                  },
                  axisPointer: {
                    lineStyle: {
                      color: '#57617B'
                    }
                  }
                },
                color: ["#FFE4B5", "#FFA500", "#ff0000", "#ADFF2F", "#00FFFF",
                  "#FF7F50", "#00FF7F", "#FFFF00", "#FF4500", "#ff1493",
                  "#98FB98", "#9400D3", "#00FF00", "#F5F5DC", "#FFE4E1", "#F0E68C",
                  "#7FFF00", "#FF69B4", "#F0FFFF", "#FFD700", "#FA8072", "#F0FFF0", "#FFF0F5", "#FAFAD2"],
                legend: {
                  type: 'scroll',
                  icon: "circle",
                  itemWidth: 15,
                  itemHeight: 15,
                  itemGap: 15,
                  data: this.eightaveraged.legend,
                  left: "4%",
                  right: "4%",
                  top: "30",
                  textStyle: {
                    color: "#000",
                    fontSize: 20
                  }
                },
                grid: {
                  containLabel: true,
                  left: "4%",
                  right: "4%",
                  top: '100',
                  bottom: "8%"
                },
                dataZoom: [
                  {
                    type: 'inside',
                    start: 0,
                    end: 20
                  },
                  {
                    start: 0,
                    end: 20
                  }
                ],
                xAxis: {
                  type: 'category',
                  data: this.eightaveraged.xaxis,
                  axisLine: { //  改变x轴颜色
                    show: false,
                    lineStyle: {
                      color: '#26D9FF'
                    }
                  },
                  axisLabel: { //  改变x轴字体颜色和大小
                    textStyle: {
                      color: "000",
                      fontSize: 14
                    }
                  },
                  axisTick: {
                    show: false
                  },
                  splitLine: {
                    show: false,
                  }
                },
                yAxis: {
                  type: 'value',
                  // name: "(浓度值)",
                  axisLine: { //  改变y轴颜色
                    show: false,
                    lineStyle: {
                      color: '#000'
                    }
                  },
                  axisLabel: { //  改变y轴字体颜色和大小
                    //formatter: '{value} m³ ', //  给y轴添加单位
                    textStyle: {
                      color: "#000",
                      fontSize: 14
                    },
                  },
                  axisTick: {
                    show: false
                  },
                  splitLine: {
                    show: true,
                    lineStyle: {
                      color: ['#314a63'],
                    }
                  }
                },
                series: this.eightaveraged.series
              });
              window.addEventListener("resize", function () {
                myChart.resize();
              });
            } else {
              //查询成功，但暂无数据
              this.isShow = false
              if (myChart) {
                myChart.clear()
              }
              $("#yhecharts").hide();
              $("#datams").hide();
            }
          } else {
          }
        });
      }
    },
    handleClick() {
      this.isiptShow = true;
    },
    //节点选中状态发生变化时的回调
    handleCheckChange(data) {
      if (data.deviceId) {
        this.value = data.label
        this.dataForm.deviceId = data.deviceId
      }
      if (data.children.length == 0) {
        this.isiptShow = false
      }
    },
    //节点过滤
    filterNode(value, data) {
      if (!value) return true;
      if (!data.label) return false;
      if (!data.uniqueCode) return false;
      return data.label.indexOf(value) !== -1 || data.uniqueCode.indexOf(value) !== -1
    },
    //格式化
    dateFormat(row, column) {
      let date = row[column.property];
      return this.$moment(date).format("YYYY年MM月DD日")
    },
    // 获取设备数据列表
    getDataList: function () {
      if (this.dateEnum == 0) {
        this.isiptShow = false;
        //时间条件
        if (this.dataForm.dateStr) {
          this.dataForm.dateFromStr = this.dataForm.dateStr[0]
          this.dataForm.dateToStr = this.dataForm.dateStr[1]
        } else {
          this.msg = "请选择时间";
          this.$message.warning(this.msg)
          return
        }
        //下拉框是否有选中
        if (this.value === '') {
          this.msg = this.labelNew
          this.$message.warning('请' + this.labelNew)
          return
        }
        this.dataList = [];
        this.tableHead = [];
        this.dataListLoading = true
        this.$http({
          url: this.$http.adornUrl('device/record/lst'),
          method: 'get',
          params: this.$http.adornParams({
            'pageNum': this.pageIndex,
            'pageSize': this.pageSize,
            'deviceId': this.dataForm.deviceId,
            'dateFromStr': this.dataForm.dateFromStr,
            'dateToStr': this.dataForm.dateToStr,
            'dateEnum': this.dateEnum,
          })
        }).then(({ data }) => {
          if (data) {
            if (data.code === 200) {
              //当查询有数据时
              if (data.data.length !== 0) {
                this.isShow = true;
                this.tableHead = data.data.head;
                this.dataList = data.data.rows;
                this.sbmc = data.data.info.name;
                this.ssqy = data.data.info.companyName;
                this.ssdw = data.data.info.address;
                this.wybm = data.data.info.code;
                this.totalPage = data.data.total;
                this.eightaveraged = data.data.echarts;
                this.colspan = Object.keys(data.data.head).length;
                // 基于准备好的dom，初始化echarts实例
                document.getElementById('yhecharts').innerHTML = "";
                document.getElementById("yhecharts").removeAttribute("_echarts_instance_");
                myChart = this.$echarts.init(document.getElementById('yhecharts'))
                // 绘制图表
                myChart.setOption({
                  tooltip: {
                    trigger: 'axis',
                    textStyle: {
                      align: 'left'
                    },
                    axisPointer: {
                      lineStyle: {
                        color: '#57617B'
                      }
                    }
                  },
                  color: ["#FFE4B5", "#FFA500", "#ff0000", "#ADFF2F", "#00FFFF",
                    "#FF7F50", "#00FF7F", "#FFFF00", "#FF4500", "#ff1493",
                    "#98FB98", "#9400D3", "#00FF00", "#F5F5DC", "#FFE4E1", "#F0E68C",
                    "#7FFF00", "#FF69B4", "#F0FFFF", "#FFD700", "#FA8072", "#F0FFF0", "#FFF0F5", "#FAFAD2"],
                  legend: {
                    type: 'scroll',
                    icon: "circle",
                    itemWidth: 15,
                    itemHeight: 15,
                    itemGap: 15,
                    data: this.eightaveraged.legend,
                    left: "4%",
                    right: "4%",
                    top: "30",
                    textStyle: {
                      color: "#000",
                      fontSize: 20
                    }
                  },
                  grid: {
                    containLabel: true,
                    left: "4%",
                    right: "4%",
                    top: '100',
                    bottom: "4%"
                  },
                  xAxis: {
                    type: 'category',
                    data: this.eightaveraged.xaxis,
                    axisLine: { //  改变x轴颜色
                      show: false,
                      lineStyle: {
                        color: '#26D9FF'
                      }
                    },
                    axisLabel: { //  改变x轴字体颜色和大小
                      textStyle: {
                        color: "000",
                        fontSize: 14
                      }
                    },
                    axisTick: {
                      show: false
                    },
                    splitLine: {
                      show: false,
                    }
                  },
                  yAxis: {
                    type: 'value',
                    name: "(浓度值)",
                    axisLine: { //  改变y轴颜色
                      show: false,
                      lineStyle: {
                        color: '#000'
                      }
                    },
                    axisLabel: { //  改变y轴字体颜色和大小
                      //formatter: '{value} m³ ', //  给y轴添加单位
                      textStyle: {
                        color: "#000",
                        fontSize: 14
                      },
                    },
                    axisTick: {
                      show: false
                    },
                    splitLine: {
                      show: true,
                      lineStyle: {
                        color: ['#314a63'],
                      }
                    }
                  },
                  series: this.eightaveraged.series
                });
                window.addEventListener("resize", function () {
                  myChart.resize();
                });
              } else {
                //查询成功，但暂无数据
                this.isShow = false
                this.msg = data.msg
                if (myChart) {
                  myChart.clear()
                }
                $("#yhecharts").hide()
              }
              this.dataListLoading = false
            } else {
              this.dataList = []
              this.totalPage = 0
              this.$message.error(data.msg);
            }
          } else {
            this.dataList = []
            this.totalPage = 0
            this.$message.error(data.msg);
          }
          // this.msg = data.msg
        })
      } else {
        this.isiptShow = false;
        //时间条件
        if (this.dataForm.dateStr) {
          this.dataForm.dateFromStr = this.dataForm.dateStr[0]
          this.dataForm.dateToStr = this.dataForm.dateStr[1]
        } else {
          this.msg = "请选择时间";
          this.$message.warning(this.msg)
          return
        }
        //下拉框是否有选中
        if (this.value === '') {
          this.msg = this.labelNew
          this.$message.warning('请' + this.labelNew)
          return
        }
        this.dataList = [];
        this.tableHead = [];
        this.dataListLoading = true
        this.$http({
          url: this.$http.adornUrl('/device/record/lst'),
          method: 'get',
          params: this.$http.adornParams({
            'pageNum': this.pageIndex,
            'pageSize': this.pageSize,
            'deviceId': this.dataForm.deviceId,
            'dateFromStr': this.dataForm.dateFromStr,
            'dateToStr': this.dataForm.dateToStr,
            'dateEnum': this.dateEnum,
          })
        }).then(({ data }) => {
          if (data) {
            if (data.code === 200) {
              //当查询有数据时
              if (data.data.length !== 0) {
                this.isShow = true;
                this.tableHead = data.data.head;
                this.dataList = data.data.rows;
                this.sbmc = data.data.info.name;
                this.ssqy = data.data.info.companyName;
                this.ssdw = data.data.info.address;
                this.wybm = data.data.info.code;
                this.totalPage = data.data.total;
                this.eightaveraged = data.data.echarts;
                // 基于准备好的dom，初始化echarts实例
                document.getElementById('yhecharts').innerHTML = "";
                document.getElementById("yhecharts").removeAttribute("_echarts_instance_");
                myChart = this.$echarts.init(document.getElementById('yhecharts'))
                // 绘制图表
                myChart.setOption({
                  tooltip: {
                    trigger: 'axis',
                    textStyle: {
                      align: 'left'
                    },
                    axisPointer: {
                      lineStyle: {
                        color: '#57617B'
                      }
                    }
                  },
                  color: ["#FFE4B5", "#FFA500", "#ff0000", "#ADFF2F", "#00FFFF",
                    "#FF7F50", "#00FF7F", "#FFFF00", "#FF4500", "#ff1493",
                    "#98FB98", "#9400D3", "#00FF00", "#F5F5DC", "#FFE4E1", "#F0E68C",
                    "#7FFF00", "#FF69B4", "#F0FFFF", "#FFD700", "#FA8072", "#F0FFF0", "#FFF0F5", "#FAFAD2"],
                  legend: {
                    type: 'scroll',
                    icon: "circle",
                    itemWidth: 15,
                    itemHeight: 15,
                    itemGap: 15,
                    data: this.eightaveraged.legend,
                    left: "4%",
                    right: "4%",
                    top: "30",
                    textStyle: {
                      color: "#000",
                      fontSize: 20
                    }
                  },
                  grid: {
                    containLabel: true,
                    left: "4%",
                    right: "4%",
                    top: '100',
                    bottom: "4%"
                  },
                  xAxis: {
                    type: 'category',
                    data: this.eightaveraged.xaxis,
                    axisLine: { //  改变x轴颜色
                      show: false,
                      lineStyle: {
                        color: '#26D9FF'
                      }
                    },
                    axisLabel: { //  改变x轴字体颜色和大小
                      textStyle: {
                        color: "000",
                        fontSize: 14
                      }
                    },
                    axisTick: {
                      show: false
                    },
                    splitLine: {
                      show: false,
                    }
                  },
                  yAxis: {
                    type: 'value',
                    name: "(浓度值)",
                    axisLine: { //  改变y轴颜色
                      show: false,
                      lineStyle: {
                        color: '#000'
                      }
                    },
                    axisLabel: { //  改变y轴字体颜色和大小
                      //formatter: '{value} m³ ', //  给y轴添加单位
                      textStyle: {
                        color: "#000",
                        fontSize: 14
                      },
                    },
                    axisTick: {
                      show: false
                    },
                    splitLine: {
                      show: true,
                      lineStyle: {
                        color: ['#314a63'],
                      }
                    }
                  },
                  series: this.eightaveraged.series
                });
                window.addEventListener("resize", function () {
                  myChart.resize();
                });
              } else {
                //查询成功，但暂无数据
                this.isShow = false
                if (myChart) {
                  myChart.clear()
                }

                $("#yhecharts").hide()
              }
              this.dataListLoading = false
            } else {
              this.dataList = []
              this.totalPage = 0
              this.$message.error(data.msg);
            }
          } else {
            this.dataList = []
            this.totalPage = 0
            this.$message.error(data.msg);
          }
          this.msg = data.msg

        })
      }

    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    //导出excel
    tempExcel() {
      //时间条件
      if (this.dataForm.dateStr) {
        this.dataForm.dateFromStr = this.dataForm.dateStr[0]
        this.dataForm.dateToStr = this.dataForm.dateStr[1]
      } else {
        this.msg = "请选择时间";
        this.$message.warning(this.msg)
        return
      }
      //下拉框是否有选中
      if (!this.value) {
        this.msg = this.labelNew
        this.$message.warning('请' + this.labelNew)
        return
      }
      //这里的设备下拉框就是上面遍历的数据源
      // let obj = this.options.find((item) => {
      //   //筛选出匹配数据
      //   return item.value === this.value;
      // });
      const loading = this.$loading({
        lock: true,
        text: '导出中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      excel("/device/record/excel", this.value + "-" + this.$moment(new Date()).format("yyyyMMDDHHmm"), {
        'pageNum': this.pageIndex,
        'pageSize': this.pageSize,
        'deviceId': this.dataForm.deviceId,
        'dateFromStr': this.dataForm.dateFromStr,
        'dateToStr': this.dataForm.dateToStr,
        'dateEnum': this.dateEnum,
      }, loading.close(), this.$message({
        message: '导出成功',
        type: 'success',
        duration: 3000,
        showClose: true,
        onClose: () => { }
      })
      )
    },
    //echarts图表
    echarts() {
      this.number = '0';
      myChart.resize();
      $("#yhecharts").show();
      $("#datams").show();
      $(".el-table--border").hide();
      $(".el-pagination").hide();
      myChart.resize();
    },
    //重置
    reload() {
      this.number = '1';
      $(".el-table--border").show();
      $(".el-pagination").show();
      $("#yhecharts").hide();
      $("#datams").hide();
      this.getDataList();
    },
    //分钟
    getMinutes() {
      this.minuteValue = true
      this.hourValue = false
      this.dayValue = false
      this.pageIndex = 1
      this.dataForm.formatTime = "yyyy-MM-dd HH:mm";
      //动态设置默认时间
      this.dataForm.dateStr = [this.$moment(new Date()).add(-1, "days").format("yyyy-MM-DD HH:mm"),
      this.$moment(new Date()).format("yyyy-MM-DD HH:mm")]
      this.pageSize = 60;
      this.isiptShow = false;
      if (this.number == "1") {
      } else {
        this.echarts();
      }
      this.dateEnum = '0';
      this.minute = 'primary';
      this.hour = '';
      this.day = '';
      if (this.dataForm.dateStr) {
        this.getDataList();
      }
    },
    //小时
    getHours() {
      this.minuteValue = false
      this.hourValue = true
      this.dayValue = false
      this.pageIndex = 1
      this.dataForm.formatTime = "yyyy-MM-dd HH";
      //动态设置默认时间
      this.dataForm.dateStr = [this.$moment(new Date()).add(-1, "days").format("yyyy-MM-DD HH"),
      this.$moment(new Date()).format("yyyy-MM-DD HH")]
      this.pageSize = 24;
      this.isiptShow = false;
      if (this.number == "1") {
      } else {
        this.echarts();
      }
      this.dateEnum = '1';
      this.hour = 'primary';
      this.minute = '';
      this.day = '';
      if (this.dataForm.dateStr) {
        this.getDataList();
      }
    },
    //日
    getDayAvgs() {
      this.minuteValue = false
      this.hourValue = false
      this.dayValue = true
      this.pageIndex = 1
      this.dataForm.formatTime = "yyyy-MM-dd";
      //动态设置默认时间
      this.dataForm.dateStr = [this.$moment(new Date()).add(-8, "days").format("yyyy-MM-DD"),
      this.$moment(new Date()).add(-1, "days").format("yyyy-MM-DD")]
      this.pageSize = 15;
      this.isiptShow = false;
      if (this.number == "1") {
      } else {
        this.echarts();
      }
      this.dateEnum = '3';
      this.day = 'primary';
      this.hour = '';
      this.minute = ''
      if (this.dataForm.dateStr) {
        this.getDataList();
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/datacenter/monitDataQuery.vue